<ng-content></ng-content>
@if (currency) {
  <div class="decimal-currency" textHiding [tooltip]="currency">
    <span>{{currency}}</span>
  </div>
}
<div class="decimal-spin-container" [class.-disabled]="decimalInput?.isDisabled">
  <svg class="-step-up_icon" (click)="stepUp()">
    <use xlink:href="#step-up"></use>
  </svg>
  <svg class="-step-down_icon" (click)="stepDown()">
    <use xlink:href="#step-down"></use>
  </svg>
</div>
